
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useVehiculoStore } from '../../../store';
import { DisenioPaginas } from '../../layout';
import { CargandoMedio, FormCreateUpdateVehiculo } from '../../components';

// import moment from 'moment';
// const now = moment().hours(0).minutes(0).seconds(0);




export const ActualizarVehiculo = () => {


    const { id } = useParams();
    const { startVehiculoPorID, activeVehiculo, vehiculoClear, isLoadingvehiculo } = useVehiculoStore();  



    useEffect(() => {
        if( id ){ startVehiculoPorID(id) }
        return () => { vehiculoClear() }
    }, [id])




    // const handleCrearVehiculo = async(e) => {
    //     e.preventDefault();
    //     if( [placa, modelo, conductor].includes('') ){
    //         return Swal.fire('Error', 'Por Favor Llenar Todos Los Campos', 'error');
    //     }
    //     await Swal.fire({
    //         title: 'Acualizar Vehiculo?',
    //         text: `Esta Seguro De Actualizar Este Vehiculo`,
    //         icon: 'question',
    //         showCancelButton: true,
    //         confirmButtonText: 'Si, Actualizar' 
    //     }).then( ( result ) => {
    //     if(result.value){
    //         startSavingVehiculo( formUser );
    //         setFormUser( initialState );
    //         navigate('/admin/list-vehiculo');
    //     }
    //     });
    // }

    const initialState = (activeVehiculo) ? {
        placa: activeVehiculo?.placa || '',
        modelo: activeVehiculo?.modelo || '',
        conductor: activeVehiculo?.conductor || '',
        soatInicio: activeVehiculo?.soatInicio || '',
        tecnoInicio: activeVehiculo?.tecnoInicio || '',
        todoRiesgoInicio: activeVehiculo?.todoRiesgoInicio || '',
    } : {}



    return (

        <DisenioPaginas titulo="Actualizar Vehiculo" url={1} add={false} subtitulo="Información del vehiculo">
            {(isLoadingvehiculo)
            ?   <CargandoMedio titulo="Cargando Información..." />   
            :   <FormCreateUpdateVehiculo initialState={initialState} />
            }
        </DisenioPaginas>

    )
}
